import { render, staticRenderFns } from "./PaneTitle.vue?vue&type=template&id=722c040c&scoped=true"
import script from "./PaneTitle.vue?vue&type=script&lang=js"
export * from "./PaneTitle.vue?vue&type=script&lang=js"
import style0 from "./PaneTitle.vue?vue&type=style&index=0&id=722c040c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722c040c",
  null
  
)

export default component.exports